import format from 'date-fns/format';

const handleNaN = (fn) => {
  return (...args) => {
    if (Number.isNaN(parseFloat(args[0], 10))) return '';
    return fn(...args);
  };
};
export const TRANSFORMS = {
  DOLLARS: handleNaN((value) => {
    const rounded = Math.round(parseFloat(value, 10) * 100) / 100;
    const isNegative = (value < 0);
    const [number, decimal] = `${rounded}`.split('.');
    const formatted = `${number}`
      .split('')
      .reverse()
      .reduce((acc, char, i) => {
        if (i % 3 || i === 0) return `${char}${acc}`;
        if (char === '-') return `${acc}`;
        return `${char},${acc}`;
      }, '');
    return decimal
      ? `$${isNegative ? '-' : ''}${formatted} .${decimal}`
      : `$${isNegative ? '-' : ''}${formatted}`;
  }),
  PERCENT: handleNaN((num) => `${Math.round(parseFloat(num) * 1000) / 10}%`),
  PERCENT_DECIMAL: handleNaN((num) => `${Math.round(parseFloat(num) * 1000) / 1000}%`),
  NUMBER: handleNaN((num) => Math.floor(parseFloat(num) * 1000) / 1000),
  NUMBER_DECIMAL: handleNaN((num) => Math.floor(parseFloat(num) * 100) / 100),
  SMALL_NUMBER: handleNaN((num) => parseFloat(num).toPrecision(8)),
  TEXT: (str) => str,
  TEXT_MAP: (str, map) => (map[str] ? map[str] : ''),
  DATE: (str) => format(new Date(str), 'LLL d y'),
};
